import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';

function WarningSection(props) {
  const { t } = props;
  return (
    <div className="warningWrapper">
      <h5 className="warning-title">{t('warning')}</h5>
      <p className="warning-explanation">{t('warning.order.change')}</p>
      <p className="warning-question">{t('warning.order.change.continue')}</p>
    </div>
  );
}

WarningSection.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(WarningSection);
